"use client";

import { useAuth } from "@clerk/nextjs";
import { useUserLGSs } from "modules/lgs/hooks/useUserLGSs";

/**
 * Viewer-vs-owner shared-store detection, shared by StoreChips and TraderCard.
 * ChatHeader calls it directly too, for the mobile trigger's menu — its
 * subtitle goes through StoreChips like everything else.
 * Detection is skipped when disabled or when the viewer IS the owner —
 * useUserLGSs treats an empty id as "don't fetch".
 */
export function useSharedStores(opts?: {
  ownerId?: string;
  enabled?: boolean;
}) {
  const { userId } = useAuth();
  const active =
    (opts?.enabled ?? true) && !!userId && userId !== opts?.ownerId;
  const { storeIds } = useUserLGSs(active && userId ? userId : "");
  const sharedIds = new Set(storeIds);

  const sortSharedFirst = <T extends { wotcId: number }>(stores: T[]): T[] =>
    [...stores].sort(
      (a, b) =>
        Number(sharedIds.has(b.wotcId)) - Number(sharedIds.has(a.wotcId))
    );

  return { sharedIds, sortSharedFirst };
}
